import { Injectable } from '@angular/core';
import { SettingsProvider } from '../../services/settings/settings';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { SharedDataProvider } from '../shared-data/shared-data';

@Injectable()
export class HelperProvider {
  //TODO : fix version manualy
  webVersion = '6.0.16';

  constructor(
    public router: Router,
    public sharedData: SharedDataProvider,
    public platform: Platform,
    public settings: SettingsProvider
  ) {
    // console.log('Hello HelperProvider Provider');
  }

  async newPlayerId() {
    // return Math.floor(Math.random() * 9000) + 1000;
    return 0;
  }

  async generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 =
      (typeof performance !== 'undefined' &&
        performance.now &&
        performance.now() * 1000) ||
      0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
  }

  async needUpdate(versionA, versionB) {
    var versionsA = versionA.split(/\./g),
      versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
      var a = Number(versionsA.shift()),
        b = Number(versionsB.shift());
      if (a == b) continue;
      return a > b || isNaN(b);
    }
    return false;
  }

  async openStartPage() {
    let startPage = await this.getStartPage();
    // console.log('openStartPage');
    // console.log(startPage);
    await this.settings.set('currentTeam', '378');
    await this.settings.set('currentPlayer', '8914');
    await this.router.navigateByUrl(startPage.startPage);
  }

  async fillShared() {
    this.sharedData.isTablet = this.platform.is('tablet');
    this.sharedData.isLogged = await this.settings.get('isLogged');
    // console.log('sharedData');
    // console.log(this.sharedData);
  }

  async getStartPage() {
    await this.fillShared();
    return { startPage: 'games' };

    // if (this.sharedData.isLogged) {
    //   // let dstPage = 'dashboard';
    //   // let dstPage = 'live-game';
    //   let dstPage = 'new-game';
    //   return { startPage: dstPage };
    // } else {
    //   return { startPage: 'login' };
    // }
  }

  resolvePlatformAsset(asset): string {
    if (this.platform.is('ios')) {
      return 'www/' + asset;
    } else {
      return asset;
    }
  }

  base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  currencyFormat(value) {
    value = parseFloat(value);
    value = value.toLocaleString('el-GR', {
      style: 'currency',
      currency: 'EUR',
    });
    return value;
  }
}
